import Swiper from 'swiper';

window.addEventListener('initCrossSellsAkascroll', event => {

    function resolveAfter2Seconds() {
        return new Promise(resolve => {
            setTimeout(() => {
                let crossSellsModal = document.getElementById('modal-showModalCrossSells')
                let crossSells = Array.from(crossSellsModal.getElementsByClassName('cross-sells-container'));

                crossSells.forEach(function (item) {
                    let id = '#' + item.getAttribute('id');

                    let swiper = new Swiper(id, {
                        slidesPerView: 'auto',
                        spaceBetween: 0,
                        freeMode: true,
                    });
                })
            }, 500);
        });
    }

    async function asyncCall() {
        const result = await resolveAfter2Seconds();
    }

    asyncCall();
})

Livewire.on('crossSellAdded', itemID => {
    let item = document.getElementById('cross-sell-item-' + itemID);
    //if is in cart page change animation
    if (item.classList.contains('cart-cross-sells')) {
        item.classList.add('active-cart');
        setTimeout(function () {
            item.classList.remove('active-cart');
        }, 1700);
    } else {
        item.classList.add('active');
        setTimeout(function () {
            item.classList.remove('active');
        }, 500);
    }

})

window.crossSellsModalScrollEvent = function (id) {
    if (id != undefined) {
        const oldSelectedItems = document.getElementById('submitCrossSells').getAttribute('data-selectedItems');
        const targetId = id;
        let crossSellsTemp = (oldSelectedItems != '') ? oldSelectedItems.split(',') : [];

        if (crossSellsTemp.some(supp => supp == targetId)) {
            for (let index = 0; index < crossSellsTemp.length; index++) {
                if (crossSellsTemp[index] == targetId) {
                    crossSellsTemp.splice(index, 1);
                }
            }
        } else { // add if not
            crossSellsTemp.push(targetId)
        }

        Alpine.store('crossSellsModal').update(crossSellsTemp, targetId);

    }
}

window.toggleDrinkOrDessertItem = function (selectedItems, itemID) {

    let resultPrice = document.getElementById('crossSellsResults');
    let item = document.getElementById('cross-sell-item-' + itemID);
    let price = 0;

    if (item.classList.contains('active')) {
        item.classList.remove('active');
    } else {
        item.classList.add('active');
    }

    for (let index = 0; index < selectedItems.length; index++) {
        price += parseFloat(document.getElementById('cross-sell-item-' + selectedItems[index]).getAttribute('data-price'))
    }

    if (price != 0) {
        resultPrice.innerHTML = '+ ' + new Intl.NumberFormat('fr-FR', {
            style: 'currency',
            currency: 'EUR'
        }).format(price)
    } else {
        resultPrice.innerHTML = "";
    }
}